import axios from "axios";
import getEndpoint from "../getEndpoint";
import useCart from "../useCart";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

type AddToCartProps = {
    sizeId: any,
    productId: string,
    quantity: number,
    userId: string
}

type UpdateProductQuantityProps = {
    cartProductId: string,
    quantity: number
}

export function useCartFunctions({ cart, addToCart, removeProduct }: any) {

    async function GetAllProductsByUserId(id: string) {
        // If cart is initially empty, you may want to fetch from the backend
        // const response = await axios.get(`${getEndpoint()}/api/CartProduct/GetAllByUserId?id=${id}`, ngrokSkipWarning);
        // return response.data;
        return cart || [];
    }

    async function GetProductSize(props: any) {
        const response = await axios.post(`${getEndpoint()}/api/ProductSize/GetProductSize`, props, ngrokSkipWarning);
        return response.data;
    }

    async function UpdateProductQuantity(props: UpdateProductQuantityProps) {
        let cartProduct = cart?.find((cartProduct: any) => cartProduct.id === props.cartProductId);
        if (!cartProduct) return;
        cartProduct.quantity = props.quantity;
        cartProduct.totalPrice = cartProduct.quantity * cartProduct.productSizeColor.price;
        //console.log(cartProduct.productSizeColor.price);
        removeProduct(props.cartProductId);
        addToCart(cartProduct);
    }

    async function AddToCart(props: any) {
        return addToCart(props);
    }

    async function DeleteCartProduct(id: string) {
        return removeProduct(id);
    }

    return {
        GetAllProductsByUserId,
        GetProductSize,
        UpdateProductQuantity,
        AddToCart,
        DeleteCartProduct,
    };
}
